import { PackagesFeed } from '@/components/PackagesFeed';
import { PageHeader } from '@/components/PageHeader';
export function PackagesPage() {
  return <div className="relative flex h-full flex-col overflow-hidden bg-background"><PageHeader title="Packages" /><div className="@container mx-8 mb-6 flex min-h-0 flex-1 flex-col overflow-hidden rounded-[10px] border border-border bg-card shadow-card max-md:mx-3 max-md:mb-4"><PackagesFeed fullHeight /></div></div>;
}
